// // // import React from "react";
// // // import { Button } from "./ui/button";
// // // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
// // // import { Badge } from "./ui/badge";
// // // import { Edit, Trash2, Instagram, Video, FileText, ExternalLinkIcon, Folder } from "lucide-react";

// // // const FolderContentView = ({ 
// // //   contents, 
// // //   selectedContents, 
// // //   setSelectedContents, 
// // //   openEditDialog, 
// // //   handleDelete 
// // // }) => {
// // //   const toggleContentSelection = (contentId) => {
// // //     setSelectedContents(prev => 
// // //       prev.includes(contentId) 
// // //         ? prev.filter(id => id !== contentId)
// // //         : [...prev, contentId]
// // //     );
// // //   };

// // //   if (contents.length === 0) {
// // //     return (
// // //       <div className="text-center py-12">
// // //         <Folder className="w-16 h-16 text-gray-300 mx-auto mb-4" />
// // //         <h3 className="text-lg font-medium text-gray-500">Folder Kosong</h3>
// // //         <p className="text-gray-400">Belum ada konten di folder ini</p>
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
// // //       {contents.map((content) => (
// // //         <Card 
// // //           key={content.id} 
// // //           className={`shadow-sm hover:shadow-md transition-all cursor-pointer ${
// // //             selectedContents.includes(content.id) ? 'ring-2 ring-blue-500 bg-blue-50' : ''
// // //           }`}
// // //         >
// // //           <CardHeader className="pb-3">
// // //             <div className="flex justify-between items-start">
// // //               <div className="flex items-center gap-2 flex-1 min-w-0">
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={selectedContents.includes(content.id)}
// // //                   onChange={() => toggleContentSelection(content.id)}
// // //                   className="rounded"
// // //                 />
// // //                 <div className="flex-1 min-w-0">
// // //                   <CardTitle className="text-sm font-medium truncate">{content.title}</CardTitle>
// // //                   <CardDescription className="text-xs">
// // //                     {content.content_type.replace('_', ' ')} • {new Date(content.created_at).toLocaleDateString('id-ID')}
// // //                   </CardDescription>
// // //                 </div>
// // //               </div>
// // //               <div className="flex gap-1 ml-2">
// // //                 <Button 
// // //                   variant="ghost" 
// // //                   size="sm"
// // //                   className="h-7 w-7 p-0"
// // //                   onClick={() => openEditDialog(content)}
// // //                 >
// // //                   <Edit className="w-3 h-3" />
// // //                 </Button>
// // //                 <Button 
// // //                   variant="ghost" 
// // //                   size="sm"
// // //                   className="h-7 w-7 p-0 text-red-600 hover:text-red-700"
// // //                   onClick={() => handleDelete(content.id)}
// // //                 >
// // //                   <Trash2 className="w-3 h-3" />
// // //                 </Button>
// // //               </div>
// // //             </div>
// // //           </CardHeader>
// // //           <CardContent className="pt-0">
// // //             <div className="flex flex-wrap gap-1 mb-2">
// // //               {content.tags.map((tagName) => (
// // //                 <Badge key={tagName} variant="secondary" className="text-xs">
// // //                   {tagName}
// // //                 </Badge>
// // //               ))}
// // //             </div>

// // //             {content.description && (
// // //               <p className="text-gray-600 text-xs mb-3 line-clamp-2">{content.description}</p>
// // //             )}

// // //             {/* Compact Preview */}
// // //             <div className="bg-gray-50 rounded p-2">
// // //               {content.content_type === 'image' && content.content_data.url && (
// // //                 <img 
// // //                   src={content.content_data.url} 
// // //                   alt={content.title}
// // //                   className="w-full h-20 object-cover rounded"
// // //                 />
// // //               )}
// // //               {content.content_type === 'video_upload' && content.content_data.url && (
// // //                 <video 
// // //                   src={content.content_data.url} 
// // //                   className="w-full h-20 rounded object-cover"
// // //                 />
// // //               )}
// // //               {content.content_type === 'video_youtube' && content.content_data.embed_url && (
// // //                 <div className="aspect-video w-full rounded overflow-hidden">
// // //                   <iframe
// // //                     src={content.content_data.embed_url}
// // //                     title={content.title}
// // //                     className="w-full h-full rounded"
// // //                     allowFullScreen
// // //                     frameBorder="0"
// // //                   />
// // //                 </div>
// // //               )}
// // //               {(content.content_type === 'instagram_reel' || content.content_type === 'instagram_feed') && (
// // //                 <div className="w-full h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded flex items-center justify-center relative overflow-hidden">
// // //                   {content.content_data.thumbnail_url ? (
// // //                     <img 
// // //                       src={content.content_data.thumbnail_url} 
// // //                       alt={content.title}
// // //                       className="w-full h-full object-cover"
// // //                     />
// // //                   ) : (
// // //                     <div className="text-center text-white">
// // //                       <Instagram className="w-4 h-4 mx-auto mb-1" />
// // //                       <span className="text-xs">{content.content_type === 'instagram_reel' ? 'Reel' : 'Feed'}</span>
// // //                     </div>
// // //                   )}
// // //                   {content.content_data.original_url && (
// // //                     <a
// // //                       href={content.content_data.original_url}
// // //                       target="_blank"
// // //                       rel="noopener noreferrer"
// // //                       className="absolute top-1 right-1 p-1 bg-black bg-opacity-50 rounded"
// // //                     >
// // //                       <ExternalLinkIcon className="w-2 h-2 text-white" />
// // //                     </a>
// // //                   )}
// // //                 </div>
// // //               )}
// // //               {content.content_type === 'file' && (
// // //                 <div className="flex items-center gap-2 p-2 bg-white rounded">
// // //                   <FileText className="w-4 h-4 text-blue-600" />
// // //                   <span className="text-xs truncate">{content.content_data.filename || content.title}</span>
// // //                 </div>
// // //               )}
// // //               {content.content_type === 'article' && (
// // //                 <div className="text-xs text-gray-600 bg-white p-2 rounded">
// // //                   <p className="line-clamp-2">{content.content_data.text?.substring(0, 100)}...</p>
// // //                 </div>
// // //               )}
// // //             </div>
// // //           </CardContent>
// // //         </Card>
// // //       ))}
// // //     </div>
// // //   );
// // // };

// // // export default FolderContentView;

// // import React, { useEffect } from "react";
// // import { Button } from "./ui/button";
// // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
// // import { Badge } from "./ui/badge";
// // import { Edit, Trash2, Instagram, Video, FileText, ExternalLinkIcon, Folder } from "lucide-react";

// // const FolderContentView = ({ 
// //   contents, 
// //   selectedContents, 
// //   setSelectedContents, 
// //   openEditDialog, 
// //   handleDelete 
// // }) => {

// //   useEffect(() => {
// //     // If TikTok script is available, load the embeds
// //     if (window.tiktok) {
// //       window.tiktok.load();
// //     }
// //   }, [contents]);


// //   const toggleContentSelection = (contentId) => {
// //     setSelectedContents(prev => 
// //       prev.includes(contentId) 
// //         ? prev.filter(id => id !== contentId)
// //         : [...prev, contentId]
// //     );
// //   };

// //   if (contents.length === 0) {
// //     return (
// //       <div className="text-center py-12">
// //         <Folder className="w-16 h-16 text-gray-300 mx-auto mb-4" />
// //         <h3 className="text-lg font-medium text-gray-500">Folder Kosong</h3>
// //         <p className="text-gray-400">Belum ada konten di folder ini</p>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
// //       {contents.map((content) => (
// //         <Card 
// //           key={content.id} 
// //           className={`shadow-sm hover:shadow-md transition-all cursor-pointer ${
// //             selectedContents.includes(content.id) ? 'ring-2 ring-blue-500 bg-blue-50' : ''
// //           }`}
// //         >
// //           <CardHeader className="pb-3">
// //             <div className="flex justify-between items-start">
// //               <div className="flex items-center gap-2 flex-1 min-w-0">
// //                 <input
// //                   type="checkbox"
// //                   checked={selectedContents.includes(content.id)}
// //                   onChange={() => toggleContentSelection(content.id)}
// //                   className="rounded"
// //                 />
// //                 <div className="flex-1 min-w-0">
// //                   <CardTitle className="text-sm font-medium truncate">{content.title}</CardTitle>
// //                   <CardDescription className="text-xs">
// //                     {content.content_type.replace('_', ' ')} • {new Date(content.created_at).toLocaleDateString('id-ID')}
// //                   </CardDescription>
// //                 </div>
// //               </div>
// //               <div className="flex gap-1 ml-2">
// //                 <Button 
// //                   variant="ghost" 
// //                   size="sm"
// //                   className="h-7 w-7 p-0"
// //                   onClick={() => openEditDialog(content)}
// //                 >
// //                   <Edit className="w-3 h-3" />
// //                 </Button>
// //                 <Button 
// //                   variant="ghost" 
// //                   size="sm"
// //                   className="h-7 w-7 p-0 text-red-600 hover:text-red-700"
// //                   onClick={() => handleDelete(content.id)}
// //                 >
// //                   <Trash2 className="w-3 h-3" />
// //                 </Button>
// //               </div>
// //             </div>
// //           </CardHeader>
// //           <CardContent className="pt-0">
// //             <div className="flex flex-wrap gap-1 mb-2">
// //               {content.tags.map((tagName) => (
// //                 <Badge key={tagName} variant="secondary" className="text-xs">
// //                   {tagName}
// //                 </Badge>
// //               ))}
// //             </div>

// //             {content.description && (
// //               <p className="text-gray-600 text-xs mb-3 line-clamp-2">{content.description}</p>
// //             )}

// //             {/* Compact Preview */}
// //             <div className="bg-gray-50 rounded p-2">
// //               {content.content_type === 'image' && content.content_data.url && (
// //                 <img 
// //                   src={content.content_data.url} 
// //                   alt={content.title}
// //                   className="w-full h-20 object-cover rounded"
// //                 />
// //               )}
// //               {content.content_type === 'video_upload' && content.content_data.url && (
// //                 <video 
// //                   src={content.content_data.url} 
// //                   className="w-full h-20 rounded object-cover"
// //                 />
// //               )}
// //                {content.content_type === 'video_tiktok' && content.content_data.embed_html && (
// //                  <div
// //                     className="[&>blockquote]:max-w-full [&>blockquote]:min-w-0 [&>blockquote]:mx-auto [&>blockquote]:my-0"
// //                     dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }}
// //                  />
// //               )}
// //               {content.content_type === 'video_youtube' && content.content_data.embed_url && (
// //                 <div className="aspect-video w-full rounded overflow-hidden">
// //                   <iframe
// //                     src={content.content_data.embed_url}
// //                     title={content.title}
// //                     className="w-full h-full rounded"
// //                     allowFullScreen
// //                     frameBorder="0"
// //                   />
// //                 </div>
// //               )}
// //               {(content.content_type === 'instagram_reel' || content.content_type === 'instagram_feed') && (
// //                 <div className="w-full h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded flex items-center justify-center relative overflow-hidden">
// //                   {content.content_data.thumbnail_url ? (
// //                     <img 
// //                       src={content.content_data.thumbnail_url} 
// //                       alt={content.title}
// //                       className="w-full h-full object-cover"
// //                     />
// //                   ) : (
// //                     <div className="text-center text-white">
// //                       <Instagram className="w-4 h-4 mx-auto mb-1" />
// //                       <span className="text-xs">{content.content_type === 'instagram_reel' ? 'Reel' : 'Feed'}</span>
// //                     </div>
// //                   )}
// //                   {content.content_data.original_url && (
// //                     <a
// //                       href={content.content_data.original_url}
// //                       target="_blank"
// //                       rel="noopener noreferrer"
// //                       className="absolute top-1 right-1 p-1 bg-black bg-opacity-50 rounded"
// //                     >
// //                       <ExternalLinkIcon className="w-2 h-2 text-white" />
// //                     </a>
// //                   )}
// //                 </div>
// //               )}
// //               {content.content_type === 'file' && (
// //                 <div className="flex items-center gap-2 p-2 bg-white rounded">
// //                   <FileText className="w-4 h-4 text-blue-600" />
// //                   <span className="text-xs truncate">{content.content_data.filename || content.title}</span>
// //                 </div>
// //               )}
// //               {content.content_type === 'article' && (
// //                 <div className="text-xs text-gray-600 bg-white p-2 rounded">
// //                   <p className="line-clamp-2">{content.content_data.text?.substring(0, 100)}...</p>
// //                 </div>
// //               )}
// //             </div>
// //           </CardContent>
// //         </Card>
// //       ))}
// //     </div>
// //   );
// // };

// // export default FolderContentView;

// import React, { useEffect } from "react";
// import { Button } from "./ui/button";
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
// import { Badge } from "./ui/badge";
// import { Edit, Trash2, Instagram, Video, FileText, ExternalLinkIcon, Folder, AlertTriangle } from "lucide-react";

// const FolderContentView = ({ 
//   contents, 
//   selectedContents, 
//   setSelectedContents, 
//   openEditDialog, 
//   handleDelete 
// }) => {

//   useEffect(() => {
//     // Reload scripts specifically for Instagram and TikTok
//     if (window.instgrm) {
//         window.instgrm.Embeds.process();
//     }
//     if (window.tiktok) {
//         window.tiktok.load();
//     }
//   }, [contents]);

//   const toggleContentSelection = (contentId) => {
//     setSelectedContents(prev => 
//       prev.includes(contentId) 
//         ? prev.filter(id => id !== contentId)
//         : [...prev, contentId]
//     );
//   };

//   if (contents.length === 0) {
//     return (
//       <div className="text-center py-12">
//         <Folder className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//         <h3 className="text-lg font-medium text-gray-500">Folder Kosong</h3>
//         <p className="text-gray-400">Belum ada konten di folder ini</p>
//       </div>
//     );
//   }

//   return (
//     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
//       {contents.map((content) => (
//         <Card 
//           key={content.id} 
//           className={`shadow-sm hover:shadow-md transition-all cursor-pointer ${
//             selectedContents.includes(content.id) ? 'ring-2 ring-blue-500 bg-blue-50' : ''
//           }`}
//         >
//           <CardHeader className="pb-3">
//             <div className="flex justify-between items-start">
//               <div className="flex items-center gap-2 flex-1 min-w-0">
//                 <input
//                   type="checkbox"
//                   checked={selectedContents.includes(content.id)}
//                   onChange={() => toggleContentSelection(content.id)}
//                   className="rounded"
//                 />
//                 <div className="flex-1 min-w-0">
//                   <CardTitle className="text-sm font-medium truncate">{content.title}</CardTitle>
//                   <CardDescription className="text-xs">
//                     {content.content_type.replace('_', ' ')}
//                   </CardDescription>
//                 </div>
//               </div>
//               <div className="flex gap-1 ml-2">
//                 <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => openEditDialog(content)}><Edit className="w-3 h-3" /></Button>
//                 <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-600 hover:text-red-700" onClick={() => handleDelete(content.id)}><Trash2 className="w-3 h-3" /></Button>
//               </div>
//             </div>
//           </CardHeader>
//           <CardContent className="pt-0">
//             <div className="flex flex-wrap gap-1 mb-2">
//               {content.tags.map((tagName) => (
//                 <Badge key={tagName} variant="secondary" className="text-xs">{tagName}</Badge>
//               ))}
//             </div>

//             {/* Compact Preview Area */}
//             <div className="bg-gray-50 rounded p-2 min-h-[100px] flex items-center justify-center overflow-hidden relative">

//               {/* Instagram Logic */}
//               {(content.content_type === 'instagram_reel' || content.content_type === 'instagram_feed') && (
//                 <div className="w-full">
//                     {content.content_data.embed_code ? (
//                         <div className="w-full flex justify-center instagram-embed-wrapper">
//                            {/* Render Embed tanpa scaling agresif agar tidak pecah/hilang */}
//                            <div dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
//                         </div>
//                     ) : (
//                         <div className="w-full h-24 bg-gradient-to-br from-purple-500 to-pink-500 rounded flex flex-col items-center justify-center text-white p-4 text-center">
//                             <AlertTriangle className="w-6 h-6 mb-2 opacity-80" />
//                             <p className="text-xs font-bold">Embed Code Missing</p>
//                             <p className="text-[10px] opacity-75">Klik Edit dan Paste kode embed</p>
//                         </div>
//                     )}
//                 </div>
//               )}

//               {/* Other Types */}
//               {content.content_type === 'image' && content.content_data.url && (
//                 <img src={content.content_data.url} alt={content.title} className="w-full h-32 object-cover rounded" />
//               )}
//               {content.content_type === 'video_upload' && content.content_data.url && (
//                 <video src={content.content_data.url} className="w-full h-32 rounded object-cover" />
//               )}
//               {content.content_type === 'video_youtube' && content.content_data.embed_url && (
//                 <div className="aspect-video w-full rounded overflow-hidden">
//                   <iframe src={content.content_data.embed_url} title={content.title} className="w-full h-full" allowFullScreen frameBorder="0" />
//                 </div>
//               )}
//                {content.content_type === 'video_tiktok' && content.content_data.embed_html && (
//                  <div className="w-full scale-75 origin-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
//               )}
//               {content.content_type === 'file' && (
//                 <div className="flex flex-col items-center gap-2 p-2">
//                   <FileText className="w-8 h-8 text-blue-600" />
//                   <span className="text-xs text-center break-all">{content.content_data.filename || 'Dokumen'}</span>
//                 </div>
//               )}
//                {content.content_type === 'article' && (
//                 <div className="text-xs text-gray-600 bg-white p-2 rounded w-full h-24 overflow-hidden relative">
//                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-50"></div>
//                    <p>{content.content_data.text}</p>
//                 </div>
//               )}
//             </div>
//           </CardContent>
//         </Card>
//       ))}
//     </div>
//   );
// };

// export default FolderContentView;

import React, { useEffect } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { Edit, Trash2, Instagram, Video, FileText, ExternalLinkIcon, Folder, AlertTriangle } from "lucide-react";
import { formatText } from "../lib/utils"; // Import fungsi formatText

const FolderContentView = ({
  contents,
  selectedContents,
  setSelectedContents,
  openEditDialog,
  handleDelete
}) => {

  useEffect(() => {
    // Reload scripts specifically for Instagram and TikTok
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
    if (window.tiktok) {
      window.tiktok.load();
    }
  }, [contents]);

  const toggleContentSelection = (contentId) => {
    setSelectedContents(prev =>
      prev.includes(contentId)
        ? prev.filter(id => id !== contentId)
        : [...prev, contentId]
    );
  };

  if (contents.length === 0) {
    return (
      <div className="text-center py-12">
        <Folder className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-500">Folder Kosong</h3>
        <p className="text-gray-400">Belum ada konten di folder ini</p>
      </div>
    );
  }

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {contents.map((content) => (
        <Card
          key={content.id}
          className={`shadow-sm hover:shadow-md transition-all cursor-pointer ${selectedContents.includes(content.id) ? 'ring-2 ring-blue-500 bg-blue-50' : ''
            }`}
        >
          <CardHeader className="pb-3">
            <div className="flex justify-between items-start">
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <input
                  type="checkbox"
                  checked={selectedContents.includes(content.id)}
                  onChange={() => toggleContentSelection(content.id)}
                  className="rounded"
                />
                <div className="flex-1 min-w-0">
                  <CardTitle className="text-sm font-medium truncate">{content.title}</CardTitle>
                  <CardDescription className="text-xs">
                    {content.content_type.replace('_', ' ')}
                  </CardDescription>
                </div>
              </div>
              <div className="flex gap-1 ml-2">
                <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => openEditDialog(content)}><Edit className="w-3 h-3" /></Button>
                <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-600 hover:text-red-700" onClick={() => handleDelete(content.id)}><Trash2 className="w-3 h-3" /></Button>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-0">
            <div className="flex flex-wrap gap-1 mb-2">
              {content.tags.map((tagName) => (
                <Badge key={tagName} variant="secondary" className="text-xs">{tagName}</Badge>
              ))}
            </div>

            {/* Terapkan formatText di sini */}
            {content.description && (
              <p className="text-gray-600 text-xs mb-3 line-clamp-2 whitespace-pre-wrap">
                {formatText(content.description)}
              </p>
            )}

            {/* Compact Preview Area */}
            <div className="bg-gray-50 rounded p-2 min-h-[100px] flex items-center justify-center overflow-hidden relative">

              {/* Instagram Logic */}
              {(content.content_type === 'instagram_reel' || content.content_type === 'instagram_feed') && (
                <div className="w-full">
                  {content.content_data.embed_code ? (
                    <div className="w-full flex justify-center instagram-embed-wrapper">
                      {/* Render Embed tanpa scaling agresif agar tidak pecah/hilang */}
                      <div dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
                    </div>
                  ) : (
                    <div className="w-full h-24 bg-gradient-to-br from-purple-500 to-pink-500 rounded flex flex-col items-center justify-center text-white p-4 text-center">
                      <AlertTriangle className="w-6 h-6 mb-2 opacity-80" />
                      <p className="text-xs font-bold">Embed Code Missing</p>
                      <p className="text-[10px] opacity-75">Klik Edit dan Paste kode embed</p>
                    </div>
                  )}
                </div>
              )}

              {/* Other Types */}
              {content.content_type === 'image' && content.content_data.url && (
                <img src={content.content_data.url} alt={content.title} className="w-full h-32 object-cover rounded" />
              )}
              {content.content_type === 'video_upload' && content.content_data.url && (
                <video src={content.content_data.url} className="w-full h-32 rounded object-cover" />
              )}
              {content.content_type === 'video_youtube' && content.content_data.embed_url && (
                <div className="aspect-video w-full rounded overflow-hidden">
                  <iframe src={content.content_data.embed_url} title={content.title} className="w-full h-full" allowFullScreen frameBorder="0" />
                </div>
              )}
              {content.content_type === 'video_tiktok' && content.content_data.embed_html && (
                <div className="w-full scale-75 origin-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
              )}
              {content.content_type === 'file' && (
                <div className="flex flex-col items-center gap-2 p-2">
                  <FileText className="w-8 h-8 text-blue-600" />
                  <span className="text-xs text-center break-all">{content.content_data.filename || 'Dokumen'}</span>
                </div>
              )}
              {content.content_type === 'article' && (
                <div className="text-xs text-gray-600 bg-white p-2 rounded w-full h-24 overflow-hidden relative">
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-50"></div>
                  {/* Terapkan formatText di preview artikel */}
                  <p className="whitespace-pre-wrap">{formatText(content.content_data.text)}</p>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default FolderContentView;